"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StiloModalWithState = StiloModalWithState;
exports.UnstyledModal = StiloModal;
exports.StiloModal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Modal = _interopRequireDefault(require("react-bootstrap/lib/Modal"));

var _ThemeProvider = require("../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function StiloModalWithState(Component) {
  var _temp;

  return _temp = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(StiloModal, _React$Component);

    var _super = _createSuper(StiloModal);

    function StiloModal() {
      var _this;

      (0, _classCallCheck2["default"])(this, StiloModal);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
        showModal: false
      });
      return _this;
    }

    (0, _createClass2["default"])(StiloModal, [{
      key: "close",
      value: function close() {
        this.setState({
          showModal: false
        });
      }
    }, {
      key: "open",
      value: function open() {
        this.setState({
          showModal: true
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
          open: function open() {
            return _this2.open();
          },
          close: function close() {
            return _this2.close();
          },
          isOpen: this.state.showModal
        }, this.props));
      }
    }]);
    return StiloModal;
  }(_react["default"].Component), _temp;
}

function buildFooter(footer) {
  return footer ? /*#__PURE__*/_react["default"].createElement(_Modal["default"].Footer, null, footer) : null;
}

function StiloModal(_ref) {
  var classes = _ref.classes,
      title = _ref.title,
      footer = _ref.footer,
      close = _ref.close,
      isOpen = _ref.isOpen,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    className: classes.stiloModal,
    show: isOpen,
    onHide: close
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, title)), /*#__PURE__*/_react["default"].createElement(_Modal["default"].Body, null, children), buildFooter(footer));
}

StiloModal.propTypes = {
  classes: _propTypes["default"].object,
  close: _propTypes["default"].func,
  isOpen: _propTypes["default"].bool,
  footer: _propTypes["default"].node,
  title: _propTypes["default"].string,
  children: _propTypes["default"].node
};
var ThemedStiloModal = (0, _ThemeProvider.withStyles)(_style["default"])(StiloModal);
exports.StiloModal = ThemedStiloModal;
//# sourceMappingURL=bootstrap.js.map